import { z } from 'my-zod'
import { extendedProductLineOptions } from '../../internal/product-lines'
import { outfitterWaiverContentResolvedView } from './outfitter-waiver-content-resolved-view'

export const outfitterWaiverContentLegacyIntegrationView = outfitterWaiverContentResolvedView
  .pick({
    id: true,
    isoLanguageCode: true,
    productImage: true,
    waiverAgreement: true,
    waiverAgreementVersion: true,
    overviewQ1: true,
    overviewQ2: true,
    overviewQ3: true,
    overviewQ4: true,
    overviewQ5: true,
    overviewQ6: true,
    safetyVideoUrl: true,
    checkoutSafetyQ1: true,
    checkoutSafetyQ2: true,
    checkoutSafetyQ3: true,
    checkoutSafetyQ4: true,
    checkoutSafetyQ5: true,
    checkoutSafetyQ6: true,
    lastModifiedDate: true
  })
  .augment({
    operatorId: outfitterWaiverContentResolvedView.shape.outfitterId,
    productLine: z.enum(extendedProductLineOptions),
    operatorCustomProduct: outfitterWaiverContentResolvedView.shape.legacyCustomProduct,
    productImageSigned: z.string().nullish(),
    waiverAgreementPdfUrl: z.string()
  })

export type outfitterWaiverContentLegacyIntegrationView = z.infer<typeof outfitterWaiverContentLegacyIntegrationView>
